import { useEffect, useState } from 'react';
import { useLanguage } from './language-context';
import { Icon } from './icon';

// Offline chip (CB-17; design kit part `offline`, Others.dc.html L393-400): an amber
// pill that appears only while the browser reports no connection, and disappears on
// its own when it comes back (window online/offline events). Rendered in the top bar
// so every screen gets it. Styles: `.offline-chip` in top-bar.css.
function isOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}

export function OfflineChip() {
  const { t } = useLanguage();
  const [online, setOnline] = useState(isOnline);

  useEffect(() => {
    const update = () => setOnline(isOnline());
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  if (online) return null;
  return (
    <span className="offline-chip" role="status" title={t('user.shell.offline_note')}>
      <Icon name="offline" size={14} stroke={1.9} />
      {t('user.shell.offline')}
    </span>
  );
}
